import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Announcement } from "app/services/interfaces/announcement.interface";
import { BehaviorSubject, Observable, catchError, map, of, tap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class NotificationBannerService {
    private _banner: BehaviorSubject<Announcement | null> = new BehaviorSubject<Announcement | null>(null);

    constructor(private _httpClient: HttpClient) {}

    /**
     * Aviso activo cacheado (null = no hay aviso). Consumir con `| async`.
     */
    get banner$(): Observable<Announcement | null> {
        return this._banner.asObservable();
    }

    /**
     * Pide a la API el aviso activo. Un fallo (sin aviso, API caída, etc.) nunca
     * debe romper la UI: se degrada a `null` silenciosamente.
     */
    fetchActive(): Observable<Announcement | null> {
        return this._httpClient.get<{ data: Announcement | null }>("/api/v1/notifications/active").pipe(
            map((response) => response?.data ?? null),
            tap((banner) => this._banner.next(banner)),
            catchError(() => {
                this._banner.next(null);
                return of(null);
            })
        );
    }
}
